import * as React from 'react';
import styles from './index.less';
import { Modal, Radio, Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FInput from '@/components/FInput';
import * as AHooks from 'ahooks';
import fMessage from '../fMessage';

interface FAuthenticationModalProps {
  open: boolean;
  onOk?(): void;
  onCancel?(): void;
}

interface FAuthenticationModalStates {
  typeCheckbox: 'phone' | 'email';
  email: string;
  phone: string;
  captchaInput: string;
  sentCaptchaWait: number;
}

const initialState: FAuthenticationModalStates = {
  typeCheckbox: 'phone',
  email: '',
  phone: '',
  captchaInput: '',
  sentCaptchaWait: 0,
};

function FAuthenticationModal({ open, onOk, onCancel }: FAuthenticationModalProps) {
  const [$typeCheckbox, set$typeCheckbox, get$typeCheckbox] = FUtil.Hook.useGetState<
    FAuthenticationModalStates['typeCheckbox']
  >(initialState['typeCheckbox']);

  const [$email, set$email, get$email] = FUtil.Hook.useGetState<
    FAuthenticationModalStates['email']
  >(initialState['email']);
  const [$phone, set$phone, get$phone] = FUtil.Hook.useGetState<
    FAuthenticationModalStates['phone']
  >(initialState['phone']);

  const [$captchaInput, set$captchaInput, get$captchaInput] = FUtil.Hook.useGetState<
    FAuthenticationModalStates['captchaInput']
  >(initialState['captchaInput']);

  const [$sentCaptchaWait, set$sentCaptchaWait, get$sentCaptchaWait] = FUtil.Hook.useGetState<
    FAuthenticationModalStates['sentCaptchaWait']
  >(initialState['sentCaptchaWait']);

  AHooks.useMount(async () => { });

  const resetCaptchaState = React.useCallback(() => {
    set$captchaInput(initialState.captchaInput);
    set$sentCaptchaWait(initialState.sentCaptchaWait);
  }, [set$captchaInput, set$sentCaptchaWait]);

  AHooks.useAsyncEffect(async () => {
    if (open) {
      await handleData();
    } else {
      resetCaptchaState();
    }
  }, [open]);

  const handleClose = React.useCallback(() => {
    resetCaptchaState();
    onCancel?.();
  }, [onCancel, resetCaptchaState]);

  AHooks.useInterval(
    () => {
      // dispatch<OnChange_ChangingPassword_CaptchaModal_SentCaptchaWait_Action>({
      //   type: 'walletPage/onChange_ChangingPassword_CaptchaModal_SentCaptchaWait',
      //   payload: {
      //     value: walletPage.changingPassword_CaptchaModal_SentCaptchaWait - 1,
      //   },
      // });
      set$sentCaptchaWait(get$sentCaptchaWait() - 1);
    },
    $sentCaptchaWait === 0 ? undefined : 1000,
  );

  async function handleData() {
    const {
      data,
    }: {
      data: {
        mobile: string;
        email: string;
      };
    } = await FServiceAPI.User.currentUserInfo();

    set$email(data.email);
    set$phone(data.mobile);
  }

  return (
    <Modal
      open={open}
      title={
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 30,
          }}
        >
          {/* <FComponentsLib.FTitleText text={'修改支付密码验证'} type='popup' /> */}
          <FComponentsLib.FTitleText
            text={
              // 身份验证
              FI18n.i18nNext.tAuto('title_verify_identity')
            }
            type='popup'
          />

          <FComponentsLib.FTipText
            style={{ fontWeight: 400 }}
            text={
              // 由于您正在进行账户安全相关的操作，需要验证您的身份。请选择接收验证码的方式。
              FI18n.i18nNext.tAuto('msg_verification')
            }
            type='second'
          />
        </div>
      }
      onCancel={handleClose}
      footer={null}
      width={500}
      closable={!!onCancel}
      maskClosable={!!onCancel}
    >
      <div className={styles.ActivateAccountContent} style={{ paddingTop: 32 }}>
        <Space size={25} direction='vertical' style={{ width: 320 }}>
          <Space size={15} direction='vertical'>
            <FComponentsLib.FTipText
              type='third'
              text={
                // 验证方式
                FI18n.i18nNext.tAuto('flw_resetpw_verify')
              }
            />
            {$phone !== '' && (
              <Space size={10}>
                <Radio
                  checked={$typeCheckbox === 'phone'}
                  onChange={() => {
                    // dispatch<OnChange_ChangingPassword_CaptchaModal_TypeCheckbox_Action>({
                    //   type: 'walletPage/onChange_ChangingPassword_CaptchaModal_TypeCheckbox',
                    //   payload: {
                    //     value: 'phone',
                    //   },
                    // });
                    set$typeCheckbox('phone');
                  }}
                />
                <FComponentsLib.FContentText text={$phone} type='normal' />
              </Space>
            )}

            {$email !== '' && (
              <Space size={10}>
                <Radio
                  checked={$typeCheckbox === 'email'}
                  onChange={() => {
                    // dispatch<OnChange_ChangingPassword_CaptchaModal_TypeCheckbox_Action>({
                    //   type: 'walletPage/onChange_ChangingPassword_CaptchaModal_TypeCheckbox',
                    //   payload: {
                    //     value: 'email',
                    //   },
                    // });
                    set$typeCheckbox('email');
                  }}
                />
                <FComponentsLib.FContentText text={$email} type='normal' />
              </Space>
            )}
          </Space>

          <div>
            <FComponentsLib.FTipText
              type='third'
              text={
                // 验证码
                FI18n.i18nNext.tAuto('flw_signup_input_verificationcode')
              }
            />
            <div style={{ height: 5 }} />
            <Space size={10}>
              <FInput
                className={styles.verificationCodeInput}
                wrapClassName={styles.verificationCodeInput}
                size='middle'
                value={$captchaInput}
                onChange={(e) => {
                  // dispatch<OnChange_ChangingPassword_CaptchaModal_CaptchaInput_Action>({
                  //   type: 'walletPage/onChange_ChangingPassword_CaptchaModal_CaptchaInput',
                  //   payload: {
                  //     value: e.target.value,
                  //   },
                  // });
                  set$captchaInput(e.target.value);
                }}
              />
              <FComponentsLib.FRectBtn
                style={{ width: 110 }}
                disabled={$sentCaptchaWait > 0}
                type='primary'
                onClick={async () => {
                  // dispatch<OnClick_ChangingPassword_CaptchaModal_SendBtn_Action>({
                  //   type: 'walletPage/onClick_ChangingPassword_CaptchaModal_SendBtn',
                  // });

                  // const { walletPage }: ConnectState = yield select(({ walletPage }: ConnectState) => ({
                  //   walletPage,
                  // }));

                  // yield put<ChangeAction>({
                  //   type: 'change',
                  //   payload: {
                  //     changingPassword_CaptchaModal_SentCaptchaWait: 60,
                  //   },
                  // });

                  set$sentCaptchaWait(60);

                  const params: Parameters<typeof FServiceAPI.Captcha.sendVerificationCode>[0] = {
                    loginName: get$typeCheckbox() === 'email' ? get$email() : get$phone(),
                    authCodeType: 'verifyIdentity',
                  };
                  const { data, msg } = await FServiceAPI.Captcha.sendVerificationCode(params);
                  if (data) {
                    return;
                  }
                  fMessage(msg, 'error');

                  // yield put<ChangeAction>({
                  //   type: 'change',
                  //   payload: {
                  //     changingPassword_CaptchaModal_SentCaptchaWait: 0,
                  //   },
                  // });
                  set$sentCaptchaWait(0);
                }}
              >
                {$sentCaptchaWait === 0
                  ? // '获取验证码'
                  FI18n.i18nNext.tAuto('flw_signup_btn_sendcode')
                  : // : `${walletPage.changingPassword_CaptchaModal_SentCaptchaWait}秒`}
                  FI18n.i18nNext.tAuto('flw_verify_btn_sendcode_timer', {
                    timer: $sentCaptchaWait,
                  })}
              </FComponentsLib.FRectBtn>
            </Space>
          </div>
        </Space>
        <div style={{ height: 40 }} />
        <FComponentsLib.FRectBtn
          type='primary'
          disabled={$captchaInput === ''}
          onClick={async () => {
            // dispatch<OnClick_ChangingPassword_CaptchaModal_NextBtn_Action>({
            //   type: 'walletPage/onClick_ChangingPassword_CaptchaModal_NextBtn',
            // });

            const params: Parameters<typeof FServiceAPI.Captcha.verifyVerificationCode>[0] = {
              authCode: get$captchaInput(),
              address: get$typeCheckbox() === 'phone' ? get$phone() : get$email(),
              authCodeType: 'verifyIdentity',
            };

            const { errCode, data } = await FServiceAPI.Captcha.verifyVerificationCode(params);
            if (errCode !== 0 || !data) {
              return fMessage('验证码错误', 'error');
            }
            onOk?.();
          }}
        >
          {
            // 验证
            FI18n.i18nNext.tAuto('addphonenumber_btn_verify')
          }
        </FComponentsLib.FRectBtn>
      </div>
    </Modal>
  );
}

export default FAuthenticationModal;
